import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

import SendIcon from '%assets/icons/send-arrow.svg';

export const SendButton = ({ disabled, ...props }: TouchableOpacityProps) => {
	return (
		<TouchableOpacity disabled={disabled} {...props}>
			<SendIcon opacity={disabled ? 0.2 : 1} />
		</TouchableOpacity>
	);
};
